import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=2b431702"
import script from "./project_detail.vue?vue&type=script&lang=js"
export * from "./project_detail.vue?vue&type=script&lang=js"
import style0 from "./project_detail.vue?vue&type=style&index=0&id=2b431702&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports